// constants
import { showSuccessAlert } from "../../constants/alerts";
import { PowerBankActionTypes } from "./constants";

const INIT_STATE = {
  powerbanks: [],
  loading: false,
  initialLoading: false,
  error: null,
};

interface PowerBankActionType {
  type:
    | PowerBankActionTypes.API_RESPONSE_SUCCESS
    | PowerBankActionTypes.API_RESPONSE_ERROR
    | PowerBankActionTypes.GET_POWERBANKS
    | PowerBankActionTypes.ADD_POWERBANKS
    | PowerBankActionTypes.UPDATE_POWERBANKS
    | PowerBankActionTypes.DELETE_POWERBANKS;

  payload: {
    actionType?: string;
    data?: any;
    error?: string;
    message?: string;
  };
}

const PowerBank = (state: any = INIT_STATE, action: PowerBankActionType): any => {
  switch (action.type) {
    case PowerBankActionTypes.API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case PowerBankActionTypes.GET_POWERBANKS:
          return {
            ...state,
            powerbanks: action.payload.data,
            loading: false,
            initialLoading: false,
            error: null,
          };
        case PowerBankActionTypes.ADD_POWERBANKS:
        case PowerBankActionTypes.UPDATE_POWERBANKS:
        case PowerBankActionTypes.DELETE_POWERBANKS:
          showSuccessAlert(action.payload.data);
          return {
            ...state,
            loading: false,
            error: null,
          };
        default:
          return { ...state };
      }

    case PowerBankActionTypes.API_RESPONSE_ERROR:
      return {
        ...state,
        error: action.payload.error,
        loading: false,
        initialLoading: false,
      };

    case PowerBankActionTypes.GET_POWERBANKS:
    case PowerBankActionTypes.ADD_POWERBANKS:
    case PowerBankActionTypes.UPDATE_POWERBANKS:
    case PowerBankActionTypes.DELETE_POWERBANKS:
      return { ...state, loading: true, initialLoading: true };

    default:
      return { ...state };
  }
};

export default PowerBank;
